import { render, staticRenderFns } from "./Copyable.vue?vue&type=template&id=1cf02830&scoped=true&"
import script from "./Copyable.vue?vue&type=script&lang=ts&"
export * from "./Copyable.vue?vue&type=script&lang=ts&"
import style0 from "./Copyable.vue?vue&type=style&index=0&id=1cf02830&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf02830",
  null
  
)

export default component.exports